import { registerPlugin, Plugin } from '@capacitor/core'

export interface AppTrackingPlugin extends Plugin {
  isTrackingAllowed(): Promise<{ allowed: boolean }>
}

const AppTracking = registerPlugin<AppTrackingPlugin>('AppTrackingPlugin')

export default AppTracking
